<template>
	<div>
		<Header :sel="6" @changePhone="changePhone" />
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<!-- your content here -->
			<div class="banner">

			</div>
			<!--banner-->

			<!--neirong-->
			<div class="bread_bg">
				<div class="bread"> <a href="javascript:void(0)" @click="go('/')">首页</a> - <a
						href="javascript:void(0)">加入我们</a></div>
			</div>
			<div class="neirong">
				<el-table :data="list" stripe style="width: 100%">
					<el-table-column prop="position" label="职位名称" width="180">
					</el-table-column>
					<el-table-column prop="workplace" label="工作地" width="180">
					</el-table-column>
					<el-table-column prop="experience" label="工作经验要求">
					</el-table-column>
					<el-table-column prop="education" label="学历要求" width="180">
					</el-table-column>
					<el-table-column prop="positionCategory" label="职位类别" width="180">
					</el-table-column>
					<el-table-column prop="salary" label="薪资">
					</el-table-column>
					<el-table-column label="岗位职责" prop="jobDuty">
						<template slot-scope="scope">
							<el-button type="text" @click="openDialog(scope.row, 'duty')">查看</el-button>
						</template>
					</el-table-column>
					<!-- 任职资格列 -->
					<el-table-column label="任职资格" prop="qualify">
						<template slot-scope="scope">
							<el-button type="text" @click="openDialog(scope.row, 'qualify')">查看</el-button>
						</template>
					</el-table-column>
				</el-table>


			</div>
			<el-dialog :title="dialogTitle"append-to-body custom-class="custom-dialog" :visible.sync="dialogVisible" width="60%">
				<div class="dialog-content">{{ dialogContent }}</div>

			</el-dialog>

			<Footer></Footer>

		</div>

	</div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import { getRecruitList } from '@/api/reqFetch.js'
export default {
	name: '',
	layout: '',
	components: {
		Footer,
		Header
	},
	data() {
		return {
			list: [],
			showPhone: false,
			dialogVisible: false,
			dialogTitle: '',
			dialogContent: ''
		}
	},

	mounted() {
		this.getData()
	},


	methods: {
		openDialog(row, type) {
			this.dialogVisible = true
			if (type === 'duty') {
				this.dialogTitle = '岗位职责详情'
				this.dialogContent = row.jobDuty
			} else {
				this.dialogTitle = '任职资格详情'
				this.dialogContent = row.qualify
			}
		},
		go(url) {
			this.$router.replace(url)
		},
		changePhone(val) {
			this.showPhone = val
		},

		getData() {
			getRecruitList({ pageNumber: 1, pageSize: 999 }).then(res => {
				this.list = res.data.list;
			});
		},



	}
}
</script>

<style scoped>
.banner {
	background-image: url('../../assets/images/banner_09.png');
}
.custom-dialog .el-dialog__body {
  padding: 20px;
  min-height: 400px;
  overflow-y: auto;
}

.dialog-content {
  white-space: pre-line; /* 保留换行符 */
  line-height: 2;
}

</style>
